<template>
<div class="p-hw-bg">
	<div class="p-hw">
		<div class="p-hw-title">{{ baseData.title }}</div>
		<div class="p-hw-subtitle">{{ baseData.subtitle }}</div>
		<div class="p-hw-tab">
			<div
				class="li"
        :class="{active: activeIndex === i}"
				v-for="(item, i) in baseData.introduceList"
				:key="i"
        @click="tabClick(item, i)"
			>{{item.title}}</div>
      <div
        class="tab-slider"
        :style="{left: 25 * activeIndex + '%'}"
      ></div>
		</div>
    <div class="p-hw-list">
      <VueSlickCarousel v-bind="settings" ref="carousel">
        <div
          class="li"
          :class="{active: activeIndex === index}"
          v-for="(item, index) in baseData.introduceList"
          :key="index + item.name"
          @click="tabClick(item, index)"
        >
          <div class="item-box">
            <div class="item-box-list">
              <p class="title">{{item.desc}}</p>
              <p class="subtitle">{{item.subdesc}}</p>
              <div class="box-list">
                <div
                  class="box-list-li"
                  :class="{active: (item.index || 0) === i}"
                  v-for="(it, i) in item.items"
                  :key="i"
                  :style="{backgroundImage: `url(${it.logo})`}"
                  @click="iconClick(index, i)"
                ></div>
              </div>
              <p class="desc">{{item.items[item.index || 0].title}}</p>
              <p class="subdesc">{{item.items[item.index || 0].desc}}</p>
              <div class="link" v-if="item.items[item.index || 0].link">
                <a :href="item.items[item.index || 0].link" @click.prevent="openUrl(item.items[item.index || 0].link, item.items[item.index || 0].event)" target="_blank">了解更多 →</a>
              </div>
            </div>
            <img class="img-p" :src="supportWebp ? item.items[item.index || 0].picture : item.items[item.index || 0].pngPicture" alt="">

          </div>
        </div>
      </VueSlickCarousel>

    </div>
	</div>
</div>
</template>

<script>
import { workData } from '../config';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import infoCollect from '@/common/infoCollect';
import { getFromPage, getPageName } from '@/common/utils/index'

export default {
	name: 'work-component',
  components: {VueSlickCarousel},
	data() {
		return {
			baseData: workData,
      supportWebp: localStorage.isSupportWebp === 'true',
			activeIndex: 0,
      settings: {
        arrows: false,
        dots: false,
        draggable: false
      },
		};
	},
  methods: {
    tabClick(item, i) {
      this.activeIndex = i
      this.$refs.carousel.goTo(i)
    },
    // 新窗口打开链接
    openUrl (url, name) {
      infoCollect.dwCollectData('button_click', `learn_more_${name}`, 'PC', 
        {'page_name': getPageName(), 'from_item': getFromPage()}
      )
      window.open(url);
    },
    iconClick(index, i) {
      this.baseData.introduceList[index].index = i
      this.baseData = {...this.baseData}
    }
  }
};
</script>

<style lang="scss" scoped>
.p-hw-bg{
  background: #FCFCFC;
  padding: 0;
}
.p-hw {
  padding-bottom: 60px;
	padding-top: 72px;
	
	&-title {
		font-weight: 700;
		font-size: 36px;
		line-height: 48px;
		text-align: center;
		color: rgba(13, 13, 13, 0.9);
	}
	&-subtitle {
		font-weight: 400;
		font-size: 14px;
		line-height: 18px;
		text-align: center;
		color: rgba(13, 13, 13, 0.66);
		margin-top: 16px;
	}
	&-tab {
    margin: 0 auto;
		margin-top: 60px;
		height: 80px;
    display: flex;
    width: 1200px;
    position: relative;
    @media screen and (max-width: $width-l) {
      width: calc(100vw - 64px);
    }
    .li{
      width: 300px;
      line-height: 80px;
      border-bottom: 1px solid #DADCE0;
      color: rgba(13, 13, 13, 0.9);
      font-size: 18px;
      cursor: pointer;
      text-align: center;
      &:hover{
        color: #2953C8;
      }
      &.active{
        cursor: default;
        color: #2953C8;
      }
    
    }
    .tab-slider{
      position: absolute;
      left: 0;
      bottom: 0;
      width: 25%;
      height: 3px;
      background: #2953C8;
      transition: all 0.3s;
    }
	}
  &-list{
		margin-top: 60px;
    width: 100%;
    // height: 560px;
    .li{
      // height: 560px;
      .item-box{
        // height: 560px;
      }
    }
  }
  .item-box{
    position: relative;
    min-height: 560px;
    width: 1200px;
    margin: 0 auto;
    @media screen and (max-width: $width-l) {
      width: calc(100vw - 64px);
    }
    .img-p{
      position: absolute;
      right: 0px;
      top: 50%;
      transform: translate(0, -50%);
      width: 565px;
      border-radius: 24px;
      @include responsive($width-l) {
        width: calc(100% - 640px);
        min-width: 400px;
        max-width: 565px;
      }
      @include responsive($width-m) {
        width: calc(100% - 536px);
        min-width: 360px;
        max-width: 400px;
      }
      @include responsive($width-s) {
        position: static;
        width: 100%;
        transform: translate(0, 0);
        margin-top: 10px;
      }

    }
    &-list{
      width: 464px;
      padding-top: 73px;
      .title {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 600;
        font-size: 30px;
        line-height: 40px;
        color: rgba(13, 13, 13, 0.9);
      }
      .subtitle{
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: rgba(13, 13, 13, 0.66);
        margin-top: 16px;
      }
      .desc{
        font-family: 'PingFang SC';
        font-weight: 600;
        font-size: 20px;
        line-height: 32px;
        color: rgba(13, 13, 13, 0.9);
        margin-top: 24px;
      }
      .subdesc{
        font-family: 'PingFang SC';
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: rgba(13, 13, 13, 0.66);
        margin-top: 12px;
        display: -webkit-box;  
        -webkit-box-orient: vertical;  
        -webkit-line-clamp: 2;  
        overflow: hidden;  
        text-overflow: ellipsis;
      }
      .link{
        a{
          font-family: 'PingFang SC';
          font-weight: 400;
          font-size: 14px;
          line-height: 22px;
          color: #2953C8;
          &:hover{
            color: #4C75D4;
          }
          &:active{
            color: #1838A1;
          }
        }
        margin-top: 32px;
      }
      @include responsive($width-m) {
        width: 50%;
        max-width: calc(100% - 370px);
        .title {
          font-size: 22px;
        }
      }
      @include responsive($width-s) {
        width: 100%;
      }
    }
    .box-list{
      margin-top: 64px;
      display: flex;
      &-li{
        width: 64px;
        height: 64px;
        background: #FFFFFF;
        background-size: 32px;
        background-position: center;
        box-shadow: 0px 4px 30px rgba(116, 134, 163, 0.1), 0px 1px 2px rgba(116, 134, 163, 0.04);
        border-radius: 12px;
        background-repeat: no-repeat;
        cursor: pointer;
        &:hover{
          border: 1px solid #2953C8;
        }
        &.active{
          border: 2px solid #2953C8;
        }
      }

      &-li + .box-list-li{
        margin-left: 16px;
      }
      @include responsive($width-m) {
        &-li{
          width: 48px;
          height: 48px;
        }
        &-li + .box-list-li{
          margin-left: 4px;
        }
      }
    }
  }
}


</style>
